import { gql } from '@apollo/client';
import moment from 'moment';
import type { GetVerificationStatus_PostFragment } from '../graphql/generated/graphqlTypes';

export enum VerificationStatus {
  None = 'NONE',
  Verified = 'VERIFIED',
  Requested = 'REQUESTED',
  Expired = 'EXPIRED',
}

const GET_POST_VERIFICATION_STATUS_POST_FRAGMENT = gql`
  fragment getVerificationStatus_post on Post {
    verification {
      id
      insertedAt
    }
    verificationEntries {
      id
      expiredAt
    }
  }
`;

export default function getVerificationStatus({
  verification,
  verificationEntries,
}: GetVerificationStatus_PostFragment): VerificationStatus {
  const lastEntry = verificationEntries?.[0];
  const isLastEntryInTheCurrentPeriod =
    verification &&
    lastEntry &&
    (!lastEntry.expiredAt ||
      moment(lastEntry.expiredAt) > moment(verification.insertedAt));

  if (!isLastEntryInTheCurrentPeriod) {
    return verification
      ? VerificationStatus.Requested
      : VerificationStatus.None;
  }

  return lastEntry?.expiredAt
    ? VerificationStatus.Expired
    : VerificationStatus.Verified;
}

getVerificationStatus.fragments = {
  post: GET_POST_VERIFICATION_STATUS_POST_FRAGMENT,
};
